<template>
  <div class="w w1200 xy_min_height4" v-loading="loading">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="breakcrumbHeader">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>店铺列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 店铺列表 -->
    <div class="store-list">
      <el-form :model="formInline" inline class="store-list-header">
        <el-form-item>
          <el-input v-model="formInline.keyword" size="small" type="text" placeholder="店铺名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader size="small" v-model="formInline.mLocation" :props="{ checkStrictly: true }" placeholder="请选所属地区" :options="areaDatas"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <template v-if="items.length">
        <div class="store-card" v-for="item in items" :key="item.bxmId">
          <el-row>
            <el-col :span="6">
              <router-link tag="div" :to="`/shopStore?storeId=${item.bxmId}`" class="store-info clearfix">
                <el-image class="store-logo" :src="item.logo" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="info-list">
                  <div class="name">{{ item.name }}</div>
                  <div class="address">
                    <span class="gray-text">店铺地址：</span>{{ item.address }}
                  </div>
                  <div class="sort">
                    <span class="gray-text">店铺类型：</span>{{ item.sortname }}
                  </div>
                  <el-button size="mini" plain
                    @click.stop="toggleCollect(item)"
                    :type="item.isCollect === 1 ? 'default' : 'primary'"
                    :icon="item.isCollect === 1 ? 'el-icon-star-on' : 'el-icon-star-off'">
                    {{ item.isCollect === 1 ? "取消关注" : "关注店铺" }}
                  </el-button>
                </div>
              </router-link>
            </el-col>
            <el-col :span="18">
              <div class="store-goods-wrap">
                <router-link tag="div" class="trigger" :to="`/shopStore?storeId=${item.bxmId}`">更多商品</router-link>
                <div class="store-goods">
                  <div @click="$tools.showGoodInBlank(good.id)" class="good-item"
                    v-for="good in item.goods" :key="good.id">
                    <el-image class="good-cover" :src="good.photos" fit="contain">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <div class="good-name OneLineDisplay">{{ good.name }}</div>
                    <div class="good-price-count">
                      <span class="price">{{ good.price | decimal }}</span>
                      <span class="count gray-text">已售{{ item.saleNum || 0 }}件</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="formInline" @callFather="callFather"></Pagination>
      </template>
      <empty v-else>暂无店铺</empty>
    </div>
  </div>
</template>

<script>
import {storeList, addCollection, removeCollection} from "../../api/xunyou";
import Pagination from "@/components/Pagination";

export default {
  name: "store",
  data() {
    return {
      items: [],
      loading: true,
      formInline: {
        keyword: '',
        mLocation: '',
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
    };
  },
  // 注册组件
  components: {Pagination},
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    areaDatas () {
      return this.$store.state.getprovince;
    }
  },
  created() {
    this.searchStoreList();
  },
  methods: {
    // 转换地区编码格式为后端需要的格式
    getLocationCode () {
      let code = '';
      if (this.formInline.mLocation.length) {
        const sliceLen = this.formInline.mLocation.length * 2;
        const sliceCode = this.formInline.mLocation[this.formInline.mLocation.length - 1];
        code = sliceCode.toString().substr(0, sliceLen);
      }
      return code;
    },
    // 重置
    reset () {
      this.formInline.keyword = '';
      this.formInline.mLocation = '';
      this.search();
    },
    // 查询
    search () {
      this.formInline.currentPage = 1;
      this.formInline.pageSize = 10;
      this.searchStoreList();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.searchStoreList();
    },
    // 店铺查询
    searchStoreList() {
      this.loading = true;
      storeList({
        name: this.formInline.keyword,
        companyLocation: this.getLocationCode(),
        userId: this.userId,
        pageSize: this.formInline.pageSize,
        pageNum: this.formInline.currentPage
      }).then((res) => {
        console.log('店铺列表：', res);
        this.loading = false;
        if (res.code === 0) {
          this.items = res.rows;
          this.formInline.total = res.total;
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("店铺查询失败，请稍后再试！");
      });
    },
    toggleCollect(store) {
      this.$tools.isLogin(() => {
        const req = {
          type: 2, //1:商品；2：店铺；必填
          uid: this.userId,
          cid: store.bxmId,
        };
        let promise = null;
        if (store.isCollect === 1) {
          store.isCollect = 0;
          promise = removeCollection(req);
        } else {
          store.isCollect = 1;
          promise = addCollection(req);
        }
        promise.then((res) => {
          console.log("收藏操作结果：", res);
        });
      });
    },
  },
};
</script>

<style scoped lang='less'>
.store-list{
  min-height: 300px;
}
.store-list-header{
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
  /deep/ .el-form-item{
    margin-bottom: 0;
  }
}
.store-card {
  padding: 15px;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;

  .gray-text {
    color: #888888;
  }

  .store-logo {
    float: left;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  .info-list {
    padding-left: 80px;

    .name {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .sort {
      margin-bottom: 20px;
    }
  }

  .store-goods-wrap {
    position: relative;

    .trigger {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 10;
      writing-mode: vertical-lr;
      padding: 0 10px;
      letter-spacing: 5px;
      text-align: center;
      background: linear-gradient(90deg, #f9f9f9, #fffffffc);
      cursor: pointer;
    }
  }

  .store-goods {
    position: relative;
    height: 172px;
    white-space: nowrap;
    overflow-x: auto;
    padding: 10px 0;
    box-sizing: border-box;
    border-left: 1px dashed #edefdd;
  }

  .good-item {
    display: inline-block;
    box-shadow: 0px 0px 10px rgba(172, 172, 172, 0.2);
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;

    .good-cover {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }

    .good-name {
      max-width: 100px;
    }

    .good-price-count {
      line-height: 1;
      margin-top: 5px;

      .price {
        color: var(--main-theme-color);
        font-size: 14px;
        float: left;

        &:before {
          content: "￥";
          font-size: 12px;
        }
      }

      .count {
        float: right;
      }
    }
  }
}

.pagination {
  text-align: right;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #fff;
    width: 20px;
  }

  /deep/ .el-pagination.is-background .btn-next,
  /deep/ .el-pagination.is-background .btn-prev,
  /deep/ .el-pagination.is-background .el-pager li {
    width: 20px;
  }

  /deep/ input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/store/store.vue